import React from "react";
import { Link } from "react-router-dom";
import Image from "../../assets/image";
export default function GemLogo() {
  return (
    <Link to="/">
      <img
        className="w-12 h-12 sm:w-16 sm:h-16 lg:w-28 lg:h-28"
        src={Image?.newlogo}
        alt="Logo"
      />
    </Link>
  );
}
